import { cva, type VariantProps } from "class-variance-authority";
import { Loader2 } from "lucide-react";
import type { ButtonHTMLAttributes } from "react";
import { cn } from "../../lib/cn";

/** Alturas mínimas de 44 px (objetivo táctil); `lg` para las acciones de decisión en móvil. */
const button = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[10px] font-semibold transition-colors disabled:opacity-50 disabled:pointer-events-none cursor-pointer select-none",
  {
    variants: {
      variant: {
        primary: "bg-ac text-acx hover:brightness-110",
        secondary: "border border-ln2 bg-transparent text-tx hover:bg-hv",
        ghost: "bg-transparent text-mu hover:text-tx hover:bg-hv",
        danger: "border border-er bg-transparent text-er hover:bg-er/10",
        success: "bg-gd text-bg hover:brightness-110",
      },
      size: { sm: "h-9 px-3 text-[13px]", md: "h-11 px-5 text-[15px]", lg: "h-[52px] px-6 text-base", icon: "h-11 w-11" },
    },
    defaultVariants: { variant: "secondary", size: "md" },
  },
);

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof button> { loading?: boolean }
export function Button({ className, variant, size, loading, children, disabled, ...p }: ButtonProps) {
  return (
    <button className={cn(button({ variant, size }), className)} disabled={disabled || loading} {...p}>
      {loading && <Loader2 className="h-4 w-4 animate-spin" aria-hidden />}
      {children}
    </button>
  );
}
